(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-collection-row"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wf-collection-carousel')) {
  customElements.define('wf-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.wf-collection-row__grid');
      const previous = this.querySelector('[data-wf-row-prev]');
      const next = this.querySelector('[data-wf-row-next]');
      if (!track || !previous || !next) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const position = Math.abs(track.scrollLeft);
        previous.disabled = position <= 2;
        next.disabled = position >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('.wf-collection-row__card');
        const distance = (card?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({left: direction * distance * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {signal, passive:true});
      this.querySelectorAll('[data-wf-pcarousel]').forEach(frame => {
        const gallery = frame.querySelector('[data-wf-pcarousel-track]');
        const dots = frame.querySelectorAll('.wf-collection-row__dot');
        if (!gallery || !dots.length) return;
        gallery.addEventListener('scroll', () => {
          const active = Math.round(Math.abs(gallery.scrollLeft) / (gallery.clientWidth || 1));
          dots.forEach((dot,index) => dot.classList.toggle('is-active',index === active));
        }, {signal,passive:true});
      });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-gifting-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wf-gift-details')) {
 customElements.define('wf-gift-details',class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.observer?.disconnect();
   this.controller=new AbortController();
   const signal=this.controller.signal;
   const rail=this.querySelector('.wf-gift-details__rail');
   const prev=this.querySelector('[data-gift-previous]');
   const next=this.querySelector('[data-gift-next]');
   if(!rail||!prev||!next)return;
   const rtl=getComputedStyle(rail).direction==='rtl';
   const update=()=>{
    const position=Math.abs(rail.scrollLeft);
    prev.disabled=position<2;
    next.disabled=position>=rail.scrollWidth-rail.clientWidth-2;
   };
   const move=direction=>{
    const item=rail.querySelector('figure');
    const distance=(item?.getBoundingClientRect().width||rail.clientWidth)+parseFloat(getComputedStyle(rail).gap||0);
    rail.scrollBy({left:direction*distance*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   };
   prev.addEventListener('click',()=>move(-1),{signal});
   next.addEventListener('click',()=>move(1),{signal});
   rail.addEventListener('scroll',update,{signal,passive:true});
   this.observer=new ResizeObserver(update);
   this.observer.observe(rail);
   update();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-scroll-of-honour"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(customElements.get('wf-honour-ritual'))return;

const EMAIL_RE=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function init(root){
  const proxyPath=root.dataset.proxyPath||'/apps/honour-letter/send';
  const recipientNameEl=root.querySelector('[data-recipient-name]');
  const senderNameEl=root.querySelector('[data-sender-name]');
  const messageEl=root.querySelector('[data-scroll-message]');
  const emailEl=root.querySelector('[data-recipient-email]');
  const preSubmit=root.querySelector('[data-pre-submit]');
  const sealBtn=root.querySelector('[data-seal]');
  const confirmBox=root.querySelector('[data-confirm]');
  const confirmText=root.querySelector('[data-confirm-text]');
  const confirmSendBtn=root.querySelector('[data-confirm-send]');
  const confirmCancelBtn=root.querySelector('[data-confirm-cancel]');
  const sealedActions=root.querySelector('[data-sealed-actions]');
  const downloadBtn=root.querySelector('[data-download-note]');
  const writeAnotherBtn=root.querySelector('[data-write-another]');
  const status=root.querySelector('[data-note-status]');

  const defaultMessage=messageEl.value;
  let lastPdfBase64=null;
  let sending=false;

  function setStatus(msg,isError){
    status.textContent=msg||'';
    if(isError)status.setAttribute('data-error','');else status.removeAttribute('data-error');
  }

  function setFieldsDisabled(disabled){
    [recipientNameEl,senderNameEl,messageEl,emailEl].forEach(el=>{el.disabled=disabled;});
  }

  function showPreSubmit(){
    preSubmit.hidden=false;
    confirmBox.hidden=true;
    sealedActions.hidden=true;
  }

  function showConfirm(){
    preSubmit.hidden=true;
    confirmBox.hidden=false;
    sealedActions.hidden=true;
  }

  function showSealed(){
    preSubmit.hidden=true;
    confirmBox.hidden=true;
    sealedActions.hidden=false;
  }

  function validate(){
    if(!messageEl.value.trim()){setStatus('Please write your letter before sending.',true);messageEl.focus();return false;}
    if(!senderNameEl.value.trim()){setStatus('Please sign your letter before sending.',true);senderNameEl.focus();return false;}
    if(!EMAIL_RE.test(emailEl.value.trim())){setStatus('Please enter a valid email address.',true);emailEl.focus();return false;}
    return true;
  }

  sealBtn.addEventListener('click',()=>{
    if(sending)return;
    if(!validate())return;
    setStatus('');
    confirmText.textContent='Send this letter to '+emailEl.value.trim()+'?';
    showConfirm();
    confirmSendBtn.focus();
  });

  confirmCancelBtn.addEventListener('click',()=>{
    showPreSubmit();
  });

  async function sendLetter(){
    sending=true;
    confirmBox.hidden=true;
    preSubmit.hidden=false;
    sealedActions.hidden=true;
    sealBtn.disabled=true;
    sealBtn.textContent='Sending…';
    setFieldsDisabled(true);
    setStatus('Sending…');

    let resp,data;
    try{
      resp=await fetch(proxyPath,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          recipientName:recipientNameEl.value.trim(),
          senderName:senderNameEl.value.trim(),
          message:messageEl.value.trim(),
          recipientEmail:emailEl.value.trim()
        })
      });
      data=await resp.json().catch(()=>({}));
    }catch(e){
      sending=false;
      sealBtn.disabled=false;
      sealBtn.textContent='Retry';
      setFieldsDisabled(false);
      setStatus('Could not reach the email service. Your letter has been kept. Please try again.',true);
      return;
    }

    sending=false;

    if(resp.ok&&data&&data.accepted){
      lastPdfBase64=data.pdfBase64||null;
      setFieldsDisabled(true);
      setStatus('Your letter is on its way.');
      showSealed();
      return;
    }

    sealBtn.disabled=false;
    sealBtn.textContent='Retry';
    setFieldsDisabled(false);
    setStatus((data&&data.message)?data.message:'Something went wrong. Your letter has been kept. Please try again.',true);
  }

  confirmSendBtn.addEventListener('click',sendLetter);

  sealBtn.addEventListener('click',(e)=>{
    if(sealBtn.textContent==='Retry'){
      sendLetter();
    }
  });

  downloadBtn.addEventListener('click',()=>{
    if(!lastPdfBase64)return;
    try{
      const byteChars=atob(lastPdfBase64);
      const byteNumbers=new Array(byteChars.length);
      for(let i=0;i<byteChars.length;i++)byteNumbers[i]=byteChars.charCodeAt(i);
      const byteArray=new Uint8Array(byteNumbers);
      const blob=new Blob([byteArray],{type:'application/pdf'});
      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');
      a.href=url;a.download='White-Flowerr-Letter.pdf';a.click();
      setTimeout(()=>URL.revokeObjectURL(url),1000);
    }catch(e){
      setStatus('Could not prepare the download.',true);
    }
  });

  writeAnotherBtn.addEventListener('click',()=>{
    recipientNameEl.value='';
    senderNameEl.value='';
    messageEl.value=defaultMessage;
    emailEl.value='';
    lastPdfBase64=null;
    sealBtn.disabled=false;
    sealBtn.textContent='Seal & send';
    setFieldsDisabled(false);
    setStatus('');
    showPreSubmit();
    messageEl.focus();
  });
}

customElements.define('wf-honour-ritual',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';init(this);}});
})();

  } catch(e) { console.error(e); }
})();
})();
